// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Tl0Oa","spin":"Loader_spin__3PZ8u"};